import { render, staticRenderFns } from "./crawl-time.vue?vue&type=template&id=8a200aec&scoped=true&"
import script from "./crawl-time.vue?vue&type=script&lang=ts&"
export * from "./crawl-time.vue?vue&type=script&lang=ts&"
import style0 from "./crawl-time.vue?vue&type=style&index=0&id=8a200aec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a200aec",
  null
  
)

export default component.exports